export default __webpack_public_path__ + "static/media/map_europe.1ae5fab9.png";